import { observer } from 'mobx-react-lite';
import { kenoBetStore } from '../../../store/kenoBetStore';
import useTranslation from '../../../hooks/useTranslation';
import { TranslationKeys } from '../../../core/constants/translationKeys';

export const PossibleOdd = observer(() => {
  const { kenoOddsBySelectedNumbersCount, isBetsClosed } = kenoBetStore;
  const t = useTranslation();

  return (
    <div className='keno-top-row'>
      {Object.keys(kenoOddsBySelectedNumbersCount).length || isBetsClosed ? null : (
        <div className='keno-title-block'>
          <div className='keno-top-row-title'>{t(TranslationKeys.ChooseNumbers)}</div>
        </div>
      )}
      <div className='keno-coef-wrapper'>
        {Object.keys(kenoOddsBySelectedNumbersCount).map((el) => {
          return (
            <div className='keno-coef-item' key={el}>
              <div className='keno-coef-number'>{kenoOddsBySelectedNumbersCount[el]}x</div>
              <div className='keno-coef-index'>
                <div className='keno-coef-index-number'>{el}</div>
                <div className='keno-coef-cub' />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
});
